// Render Module
export const STYLE_LABELS = [
  'Normal',
  'Color',
  'Width',
  'Dash',
  'Zigzag',
  'Wave',
  'Bump',
  'Unmerge',
  'Twine',
  'Merge',
  'Collide',
]
export const TIME_UNIT = 100
export const TIME_GAP = 80
export const INNERGAPS = 10
export const SCALE_GAP = 5
export const RENDER_MODE = 'Smooth'

// GreedyLayout Module
export const ORDER_TIMES = 10
export const ALPHA = 0.1 // Alignment power
export const DISTANCE_IN = 10
export const DISTANCE_OUT = 10
